module.exports = __webpack_public_path__ + "img/volume-mute.752c4444.svg";